import { Formatter, removeCurrencyFormat } from "@/utils/currencyFormatter.js";
import { date, picker, formatDate } from "@/utils/dateFormatter.js";
import AlertSystem from "../../components/AlertSystem.vue";
import moment from "moment";

export default {
  name: "adiantamento",
  components: {
    AlertSystem
  },
  computed: {
    currencyFormat: {
      get() {
        if (!this.isInputActive)
          return Formatter(this.fatura.valorAdiantamento);
        else return this.fatura.valorAdiantamento;
      },
      set(value) {
        this.fatura.valorAdiantamento = removeCurrencyFormat(value);
      },
    },
    computedDateFormatted() {
      return formatDate(this.fatura.dataVencimento);
    },
  },
  data() {
    return {
      system: {
        snackbar: {}
      },
      picker: picker,
      faturado: false,
      loadGerarFatura: false,
      ParcelasFatura: 0,
      rules: {
        maxParcelas: (value) => value <= 10 || "Limite máximo de 10 parcelas",
      },
      tiposPagamento: [],
      menuDataVencimento: false,
      DataVencimento: "",
      IdUnidade: 1,
      rangeMin: moment().format("YYYY-MM-DD"),
      rangeMax: moment().add(30, "days").format("YYYY-MM-DD"),
      isInputActive: false,
      fatura: {
        lngContrato: null,
        IdEmpresa: null,
        IdUnidade: null,
        Unidade: null,
        dataVencimento: date,
        parcelas: 1,
        FormaPagamento: null,
        valorAdiantamento: 0,
        instrucoesBoleto: "Adiantamento",
        notaFiscal: null,
        numeroNotaFiscal: null,
        adiantamento: true,
      },
      item: null,
      modalPeriodoFaturar: false,
      fixBug: false,
      headers: [
        { text: "Razão Social", value: "RazaoSocial" },
        { text: "CNPJ", value: "CNPJ" },
        { text: "Unidade", value: "Unidade" },
        { text: "Nº Contrato", value: "NumeroContrato" },
        //{ text: "Tipo Contrato", value: "TipoContrato", width: "12%" },
        { text: "Vigência", value: "VigenciaInicio", width: "14%" },
        { text: "Ações", value: "actions", align: "right", width: "12%" },
      ],
      headersDetalhes: [
        { text: "Procedimento", value: "ServicoContratado" },
        { text: "Valor Unitário", value: "ValorUnitario" },
        { text: "Qtd. Contratada", value: "QuantidadeContratada" },
        { text: "Qtd. Consumida", value: "QuantidadeConsumida" },
        { text: "Percentual realizado", value: "Percentual" },
      ],
      termos: [],
      sebraetecSelecionado: this.$route.params.Sebraetec,
      termoDetalhesCabecalho: {
        CNPJ: null,
        RazaoSocial: null,
        NumeroContrato: null,
        VigenciaInicio: "",
        VigenciaFim: "",
      },
      termoDetalhes: [],
      unidadesList: [],
      statusSelecionado: 1, // Contrato autorizado
      DiaSelecionado: null,
      search: "",
      searchDetalhes: "",
      status: 1,
      loadTermos: false,
      loadTermoDetalhes: false,
      modalTermoDetalhes: false,
      agendamento: {},
      dataInicialFatura: "",
      dataFinalFatura: "",
      menuDataInicial: false,
      menuDataFinal: false,
      unidadeSelecionada: null,
      ocorrenciasList: [],      
    };
  },
  methods: {
    faturar() {
      this.loadGerarFatura = true
      let formData = new FormData();
      formData.append(`files`, this.fatura.notaFiscal);
      // dados de faturamento
      for (let key in this.fatura) {
        if (this.fatura[key] != null) {
          formData.append(`fatura[${key}]`, this.fatura[key]);
        } else {
          formData.append(`fatura[${key}]`, "");
        }
      }
      formData.append(`parcelas`, this.fatura.parcelas);
      formData.append(`FormaPagamento`, this.fatura.FormaPagamento);

      this.axios.post("faturamentos", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      }).then(res => {
        this.loadGerarFatura = false
        this.system.snackbar = {
          snackbar: true,
          text: res.data.message,
          color: 'green'
        }
        this.modalPeriodoFaturar = false // Fechar o modal
        this.fatura.notaFiscal = res.data
        this.limparFiltros()
      }).catch(e => {
        this.system.snackbar = {
          snackbar: true,
          text: e,
          color: 'red'
        }
      })
    },
    async getFormasPagamento() {
      const { data } = await this.axios("/faturamentos/formasPagamento");
      this.tiposPagamento = data;
    },
    getUnidades() {
      this.axios("unidades").then((res) => {
        this.unidadesList = res.data;
      });
    },
    getTermos() {
      this.loadTermos = true;
      this.axios
        .get("/termos/termosAbertos", {
          params: {
            IdUnidade: this.unidadeSelecionada,
            Sebraetec: this.sebraetecSelecionado,
            Dias: 45,
          },
        })
        .then((res) => {
          this.termos = res.data.map((elem) => {
            elem.RazaoSocial = this.prepareNameFilter(elem.RazaoSocial);
            return {
              ...elem              
            };
          });
        })
        .finally(() => {
          this.loadTermos = false;
        });
    },
    adiantarFatura(item) {            
      this.fatura.Unidade = item.Unidade;
      this.fatura.IdUnidade = item.IdUnidade;
      this.fatura.IdEmpresa = item.IdEmpresa;
      this.fatura.lngContrato = item.IdContrato;
      this.modalPeriodoFaturar = true;
    },
    getTermoDetalhes(item) {
      this.loadTermoDetalhes = true;
      this.axios
        .get(`/termos/${item.IdContrato}/empresas/${item.IdEmpresa}`)
        .then((res) => {
          this.termoDetalhes = res.data;
          this.termoDetalhesCabecalho.CNPJ = res.data[0].CNPJ;
          this.termoDetalhesCabecalho.RazaoSocial = res.data[0].RazaoSocial;
          this.termoDetalhesCabecalho.NumeroContrato =
            res.data[0].NumeroContrato;
          this.termoDetalhesCabecalho.VigenciaFim = res.data[0].VigenciaFim;
          this.termoDetalhesCabecalho.VigenciaInicio =
            res.data[0].VigenciaInicio;
          this.termoDetalhes.map((elem) => {
            if (elem.QuantidadeConsumida > 0) {
              elem.Progresso = parseFloat(
                (
                  (elem.QuantidadeConsumida * 100) /
                  elem.QuantidadeContratada
                ).toFixed(0)
              );
            } else {
              elem.Progresso = 0;
            }
          });
        })
        .finally(() => {
          this.loadTermoDetalhes = false;
        });
    },
    pathDocumento(path) {
      if (path != null) {
        return `https://sis.rn.sesi.org.br/gs/${path.substring(
          2,
          path.length
        )}`;
      } else {
        return path;
      }
    },
    limparFiltros() {
      this.statusSelecionado = null;
      this.DiaSelecionado = null;
      this.unidadeSelecionada = null;
      this.sebraetecSelecionado = null;
      this.search = null;
      this.getTermos();
    },    
  },
  mounted() {    
    this.getTermos();
    this.getUnidades();
    this.getFormasPagamento();
  },
};
